module.exports = __webpack_public_path__ + "img/559e1.9f7266a5.svg";